export default __webpack_public_path__ + "static/media/5-mobile.87aaba53.png";